import { Fragment, useEffect, useRef, useState } from 'react';

import { Accordion, AccordionTab } from 'primereact/accordion';
import { InputSwitch } from 'primereact/inputswitch';
import { Slider } from 'primereact/slider';
import { RadioButton } from 'primereact/radiobutton';

import { AssetService } from '../../../../service/AssetService';

import DraggablePosition from '../../../components/DraggablePosition';
import { ToastService } from '../../../../AppToast';

const dimensions = {
  A4: { width: 787, height: 1081 },
  A5: { width: 559, height: 787 }
};

export const Menu2 = (props) => {

  const { attribute, changeAttribute, dispatchEvent } = props;

  const [activeIndex, setActiveIndex] = useState(null);

  const inputLogo = useRef(null);
  const inputBorder = useRef(null);


  const [suDungHinhNenFrom, setSuDungHinhNenFrom] = useState('pc');
  const inputBackground = useRef(null);
  const [backgrounds, setBackgrounds] = useState([]);
  const [backgroundOpacity, setBackgroundOpacity] = useState(32);

  const [borders, setBorders] = useState([]);

  useEffect(() => {
    AssetService.getList({}).then(data => {
    });
    setBackgrounds([
      '/assets/demo/images/hinh-nen/hinh-1.png',
      '/assets/demo/images/hinh-nen/hinh-2.png',
      '/assets/demo/images/hinh-nen/hinh-3.png',
      '/assets/demo/images/hinh-nen/hinh-4.png',
      '/assets/demo/images/hinh-nen/hinh-5.png',
      '/assets/demo/images/hinh-nen/hinh-6.png'
    ]);
    setBorders([
      '/assets/demo/images/hinh-nen/vien-1.png',
      '/assets/demo/images/hinh-nen/vien-2.png',
      '/assets/demo/images/hinh-nen/vien-3.png',
      '/assets/demo/images/hinh-nen/vien-4.png',
      '/assets/demo/images/hinh-nen/vien-5.png',
      '/assets/demo/images/hinh-nen/vien-6.png',
      '/assets/demo/images/hinh-nen/vien-7.png',
      '/assets/demo/images/hinh-nen/vien-8.png',
      '/assets/demo/images/hinh-nen/vien-9.png',
      '/assets/demo/images/hinh-nen/vien-10.png',
      '/assets/demo/images/hinh-nen/vien-11.png',
      '/assets/demo/images/hinh-nen/vien-12.png',
    ]);
  }, []);

  const stopPropagation = (e) => {
    e.stopPropagation();
  }

  const checkActiveIndex = (from) => {
    if (activeIndex === from) {
      setActiveIndex(null);
    }
  }

  const onSuDungQrCodeChange = (value) => {
    changeAttribute('useBarcode', value);
    if (!value) {
      checkActiveIndex(0);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#data', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#data', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }
  const onQrCodeSizeChange = (value) => {
    changeAttribute('qrCodeSize', value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '#data', property: 'width', value: `${value}px` }
    });
    dispatchEvent(event);
  }

  const onSuDungLogoChange = (value) => {
    changeAttribute('useLogo', value);
    if (!value) {
      checkActiveIndex(1);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '.logo-img', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '.logo-img', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }

  const onUploadLogo = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      if (file && file.type) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const event = new CustomEvent('setAttr', {
            detail: { selector: '.logo-img', property: 'src', value: reader.result }
          });
          dispatchEvent(event);
        }
        reader.readAsDataURL(file);
      }
    }
  }

  const onUploadBorder = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.size > 300 * 1024) {
      ToastService.error('Dung lượng file upload không được vượt quá 300kb')
      return;
    }

    const { width: maxWidth, height: maxHeight } = dimensions[attribute.pageSize] || {};

    const img = new Image();
    img.onload = () => {
      const { width, height } = img;

      if (!maxWidth || !maxHeight) {
        ToastService.error(`Kích thước khung viền vượt quá giới hạn, khuyến cáo dưới: ${attribute.pageSize}: ${dimensions[attribute.pageSize].width} x ${dimensions[attribute.pageSize].height}`)
        return;
      }

      if (width > maxWidth || height > maxHeight) {
        ToastService.error(`Kích thước khung viền vượt quá giới hạn, khuyến cáo dưới: ${attribute.pageSize}: ${dimensions[attribute.pageSize].width} x ${dimensions[attribute.pageSize].height}`)
        return;
      }

      setBorders((prevBorders) => [...prevBorders, file]);
    };

    img.onerror = () => {
      ToastService.error()
    };

    img.src = URL.createObjectURL(file);
  };



  const onLogoSizeChange = (value) => {
    changeAttribute('logoSize', value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '.logo-img', property: 'width', value: `${value}px` }
    });
    dispatchEvent(event);
  }

  const onSuDungHinhNenChange = (value) => {
    changeAttribute('useBackgroundLogo', value);
    if (!value) {
      checkActiveIndex(3);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong3', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong3', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }
  const setBackground = (value) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const event = new CustomEvent('setAttr', {
          detail: { selector: '#vong3', property: 'src', value: reader.result }
        });
        dispatchEvent(event);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', value);
    xhr.responseType = 'blob';
    xhr.send();
  }
  const onUploadBackground = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      if (file && file.type) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const event = new CustomEvent('setAttr', {
            detail: { selector: '#vong3', property: 'src', value: reader.result }
          });
          dispatchEvent(event);
        }
        reader.readAsDataURL(file);
      }
    }
  }
  const onBackgroundPositionChange = ({ top, left }) => {
    const value = `matrix(1, 0, 0, 1, ${(parseInt(left) - 63) * 4}, ${(parseInt(top)) * 5})`;
    const event = new CustomEvent('setCss', {
      detail: { selector: '#vong3', property: 'transform', value }
    });
    dispatchEvent(event);
  }
  const onBackgroundSizeChange = (value) => {
    changeAttribute('backgroundSize', value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '#vong3', property: 'width', value: `${value}px` }
    });
    dispatchEvent(event);
  }
  const onBackgroundOpacityChange = (value) => {
    setBackgroundOpacity(value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '#vong3', property: 'opacity', value: `${(value / 100)}` }
    });
    dispatchEvent(event);
  }

  const onSuDungKhungVienChange = (value) => {
    changeAttribute('useBordersBackground', value);
    if (!value) {
      checkActiveIndex(4);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong4', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong4', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }
  const setBorder = (value) => {
    const handleFile = (file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const event = new CustomEvent('setAttr', {
          detail: { selector: '#vong4', property: 'src', value: reader.result }
        });
        dispatchEvent(event);
      };
      reader.readAsDataURL(file);
    };

    if (typeof value === 'string') {
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        handleFile(xhr.response);
      };
      xhr.open('GET', value);
      xhr.responseType = 'blob';
      xhr.send();
    } else if (value instanceof File) {
      handleFile(value);
    } else {
      console.error("Unsupported value type. Must be a string (URL) or File object.");
    }
  };

  return (
    <div className="grid">
      <div className="col-12">
        <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

          <AccordionTab header={<Fragment>
            <span>Sử dụng QR code</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useBarcode} onChange={(e) => onSuDungQrCodeChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useBarcode}>
            <div className="p-fluid">
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">Tùy chỉnh kích thước</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider value={attribute.qrCodeSize} min={50} max={300} onChange={(e) => onQrCodeSizeChange(e.value)} />
                </div>
              </div>
            </div>
          </AccordionTab>

          <AccordionTab header={<Fragment>
            <span>Sử dụng logo</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useLogo} onChange={(e) => onSuDungLogoChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useLogo}>

            <div className="grid" onClick={() => inputLogo.current.click()}>
              <div className="col-12">
                <div className="image-uploader">
                  <input ref={inputLogo} type="file" accept="image/*" style={{ display: 'none' }} onChange={onUploadLogo} />
                  <i className="pi pi-image" />
                  <p>Chọn từ máy tính</p>
                </div>
              </div>
            </div>

            <div className="p-fluid">
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">Tùy chỉnh kích thước</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider min={50} max={200} value={attribute.logoSize} onChange={(e) => onLogoSizeChange(e.value)} />
                </div>
              </div>
            </div>
          </AccordionTab>

          <AccordionTab header={<Fragment>
            <span>Sử dụng hình nền</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useBackgroundLogo} onChange={(e) => onSuDungHinhNenChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useBackgroundLogo}>
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className="field-radiobutton">
                  <RadioButton inputId="suDungHinhNenFrom1" name="suDungHinhNenFrom" value="pc" checked={suDungHinhNenFrom === 'pc'} onChange={e => setSuDungHinhNenFrom(e.value)} />
                  <label htmlFor="suDungHinhNenFrom1">Chọn ảnh từ máy tính</label>
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className="field-radiobutton">
                  <RadioButton inputId="suDungHinhNenFrom2" name="suDungHinhNenFrom" value="sv" checked={suDungHinhNenFrom === 'sv'} onChange={e => setSuDungHinhNenFrom(e.value)} />
                  <label htmlFor="suDungHinhNenFrom2">Chọn ảnh nền từ thư viện</label>
                </div>
              </div>
            </div>

            {suDungHinhNenFrom === 'pc' &&
              <div className="grid" onClick={() => inputBackground.current.click()}>
                <div className="col-12">
                  <div className="image-uploader">
                    <input ref={inputBackground} type="file" accept="image/*" style={{ display: 'none' }} onChange={onUploadBackground} />
                    <i className="pi pi-image" />
                    <p>Chọn từ máy tính</p>
                  </div>
                </div>
              </div>
            }
            {suDungHinhNenFrom === 'sv' &&
              <div className="grid">
                {
                  backgrounds.map((background, index) => {
                    return (
                      <div key={index} className="col-3" onClick={() => {
                        setBackground(background)
                      }}>
                        <div className="card p-0">
                          <img src={background} alt="" width="100%" />
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            }

            <div className="grid">
              <div className="col-12">
                <DraggablePosition onChange={onBackgroundPositionChange} capitalSize={attribute.backgroundSize / 4} />
              </div>
            </div>

            <div className="p-fluid mt-4">
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">Tùy chỉnh kích thước</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider min={50} max={1200} value={attribute.backgroundSize} onChange={(e) => onBackgroundSizeChange(e.value)} />
                </div>
              </div>
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">Độ mờ</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider min={1} max={100} value={backgroundOpacity} onChange={(e) => onBackgroundOpacityChange(e.value)} />
                </div>
              </div>
            </div>
          </AccordionTab>

          <AccordionTab header={<Fragment>
            <span>Sử dụng khung viền</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useBordersBackground} onChange={(e) => onSuDungKhungVienChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useBordersBackground}>
            <div className="grid">
              <div className="col-12" onClick={() => inputBorder.current.click()}>
                <div className="image-uploader">
                  <input ref={inputBorder} type="file" accept="image/*" style={{ display: 'none' }} onChange={onUploadBorder} />
                  <i className="pi pi-image" />
                  <p>Chọn từ máy tính dung lượng không quá 300Kb</p>
                  <p>Kích thước tối đa {attribute.pageSize}: ({dimensions[attribute.pageSize].width}x{dimensions[attribute.pageSize].height})</p>
                </div>
              </div>
              {
                borders.map((border, index) => {
                  return (
                    <div key={index} className="col-3" onClick={() => {
                      setBorder(border)
                    }}>
                      <div className="card p-0">
                        <img src={typeof border === 'string' ? border : URL.createObjectURL(border)} alt="" width="100%" />
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
  );
}
